/* eslint no-console: 0 */
import Vue from 'vue';
import { Logger } from 'aws-amplify';
import uuidv4 from 'uuid/v4';

import store from '@/store';
import messenger from './messenger';
import { func } from './videoConfig';
import streamConfig from './streamConfig';
import imageConfig from './imageConfig';

const logger = new Logger('PlayerService');

Vue.prototype.$player = {

  changeVideoSource(url) {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'changeVideoSource', src: url });
    } else {
      messenger('deletePlayer');
      this.newConf = { type: 'video', url, autoPlay: true };
    }
  },
  setAutoQuality() {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'setAutoQuality' });
    } else {
      messenger('deletePlayer');
      const { dash } = store.state.project;
      this.newConf = { type: 'stream', url: dash, autoPlay: true };
    }
  },
  reCreate() {
    if (this.newConf) {
      this.createPlayer(this.newConf.type, this.newConf.url, this.newConf.autoPlay);
    }
    this.newConf = null;
  },
  unMute() {
    Vue.prototype.$eventHub.$emit('video-event', { type: 'unMute' });
  },
  toggleMute() {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'toggleMute' });
      // store.commit('toggleMute');
    } else {
      messenger('toggleMute');
    }
  },
  toggleLoop() {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'loop' });
    } else {
      messenger('toggleLoop');
    }
  },
  seekTo(time) {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'seek', time });
    } else {
      messenger('seekTo', { time });
    }
  },
  play() {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'play' });
    } else {
      messenger('play');
    }
  },
  pause() {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'pause' });
    } else {
      messenger('pause');
    }
  },
  setVolume(volume) {
    if (store.state.project.layout === '2D') {
      Vue.prototype.$eventHub.$emit('video-event', { type: 'volume', volume });
      // store.commit('volume', volume);
    } else {
      messenger('volume', { volume });
    }
  },
  stop() {
    return 'stop';
  },
  createPlayer(type, url, autoPlay = true) {
    if (store.state.project.layout === '2D') {
      store.commit('regularVideoUrl', url);
      return;
    }
    if (!type || !url) return;

    let config = {};
    if (type === 'video') {
      config = func();
    } else if (type === 'image') {
      config = imageConfig;
    } else if (type === 'stream') {
      config = streamConfig;
    }

    config.story.scenes[0].hotspots = this.generateHotspots();
    config.actions = this.generateHotspotActions();

    // Get parameters from store
    if (type === 'video' || type === 'stream') {
      const {
        startTime, volume, muted, currentTime, loopEnabled,
      } = store.state;

      config.story.scenes[0].media.options.startTime = currentTime || startTime || 0;
      config.story.scenes[0].media.options.volume = muted === true ? 0 : volume;
      config.story.scenes[0].media.options.loop = loopEnabled;
      config.story.scenes[0].media.source.levels = [{ url }];
      // config.story.scenes[0].media.source.url = `${url}#t=${currentTime}`;
      config.story.scenes[0].media.options.autoPlay = autoPlay;
    } else {
      config.story.scenes[0].media.source.url = url;
    }

    // Generate random uids
    config.uid = uuidv4();
    config.controllers.instances[0].uid = uuidv4();
    config.story.uid = uuidv4();
    config.story.scenes[0].uid = uuidv4();
    config.story.scenes[0].media.uid = uuidv4();

    messenger('createPlayer', config);
  },

  generateHotspotActions() {
    const { hotspots } = store.state;
    logger.debug('generateHotspotActions');
    const actions = hotspots.map((hs, index) => ({
      uid: `hs-click-${index}`,
      method: {
        name: 'hotspotClicked',
        args: [
          index,
        ],
      },
    }));
    return actions;
  },

  generateHotspots() {
    logger.debug('generateHotspots');
    const { hotspots } = store.state;
    const { content } = store.state.project;

    const supportedHotspotSets = [
      'hotspot_00_Default',
      'hotspot_01_General',
      'hotspot_02_Restrictions',
      'hotspot_03_Safety',
      'hotspot_04_Equipment',
      'hotspot_05_Warnings',
      'hotspot_06_Links',
      'hotspot_07_Navigation',
    ];

    const hotspotsObjects = hotspots.map((hs, index) => {
      let imageUrl;
      if (hs.customSetName && !(supportedHotspotSets.includes(hs.customSetName))) {
        imageUrl = '/icons/missing_hotspot_icon.png';
      } else {
        imageUrl = hs.customSetName ? `/${hs.customSetName}/${hs.fileName}` : `/hotspot_00_Default/${hs.fileName}.png`;
      }

      return {
        uid: `hs-${index}`,
        visible: content === 'image',
        transform:
          {
            position:
            {
              radius: 500,
              phi: hs.rotation.pitch,
              theta: hs.rotation.yaw + 180,
            },
            scale:
            {
              x: hs.scale,
              y: hs.scale,
              z: hs.scale,
            },
          },
        facingCenter: true,
        geometry:
          {
            type: 'plane',
            options:
            {
              width: 60,
              height: 60,
            },
          },
        material:
          {
            image: imageUrl,
            transparent: false,
          },
        events: {
          onClick: `hs-click-${index}`,
          onOver: `hs-on-${index}`,
          onOut: `hs-out-${index}`,
        },
        completed: false,
        timeStamp: hs.timeStamp,
        duration: hs.duration,
        pausesPlayBack: hs.pausesPlayBack,
      };
    });
    return hotspotsObjects;
  },
};
